import React from "react";
import CalendarView from "../../../../../components/CalendarView/CalendarView";

interface UpcomingInterviewCalendarProps {
  data?: any;
  handleView?: (data?: any) => void;
  handleReschedule?: (data?: any) => void;
  combinedButton?:boolean;
  handleCombinedButton?:(data?:any)=>void;
  pageName?:string;
  displayViewActionOnly?:boolean;
  rescheduleText?:string;
  combinedButtonText?:string;
}

const UpcomingInterviewCalendar: React.FC<UpcomingInterviewCalendarProps> = (
  props
) => (
  <CalendarView
    data={props?.data}
    handleView={props?.handleView}
    handleReschedule={props?.handleReschedule}
    {...props}
  />
);

export default UpcomingInterviewCalendar;
